// frontend/src/services/encuestaService.js
import axios from 'axios';
import apiClient from './apiClient';

/**
 * Encuesta de satisfacción.
 *
 * El envío de una respuesta NO usa apiClient a propósito, y es la única llamada del frontend que se
 * salta ese cliente. Dos razones, las dos importan:
 *
 *  1. apiClient mete el header Authorization en toda request. Si un empleado logueado abre el link
 *     de la encuesta en la misma pestaña, su token viajaría pegado a una respuesta que le
 *     prometimos anónima. Con axios pelado no se manda nada que lo identifique.
 *  2. apiClient, ante un 401, borra el token y redirige a /login. La encuesta es una pantalla
 *     pública: mandar al login a alguien que está respondiendo desde el celular no tiene sentido.
 *
 * La lectura de resultados sí usa apiClient: es una pantalla interna y necesita el JWT.
 */
const encuestaService = {
    /** Envía una respuesta anónima. No manda token ni ningún dato del respondente. */
    enviarRespuesta: (payload) => axios.post('/api/encuesta/respuestas', payload),

    /** Resultados agregados de una tanda. Solo PROGRAMADOR. */
    obtenerResultados: async (version) => {
        const response = await apiClient.get('/encuesta/resultados', {
            params: version ? { version } : {},
        });
        return response.data;
    },

    /** Descarga el CSV con todas las respuestas de una tanda. Solo PROGRAMADOR. */
    descargarCsv: async (version) => {
        const response = await apiClient.get('/encuesta/resultados/csv', {
            params: version ? { version } : {},
            responseType: 'blob',
        });
        return response.data;
    },
};

export default encuestaService;
